<template>
  <div class="top-navigation">
    <a href="/account" style="display: none" ref="dash"></a>
    <a href="/cart" style="display: none" ref="cart"></a>
    <a href="/account/saved-items" style="display: none" ref="saved"></a>
    <div class="nav-main">
      <div class="container">
        <!-- Top Icon  -->
        <div class="menu w-75">
          <i
            class="m-visible fi fi-br-menu-burger"
            @click="menu"
            style="font-size: 1.5rem"
            v-if="!$store.state.menuState"
          ></i>
          <router-link to="/">
            <img
              src="@/assets/logo-lg.png"
              loading="lazy"
              class="img_logo"
              width="180"
              alt=""
          /></router-link>
        </div>

        <!-- Nav Search Field -->
        <NavSearch class="search w-100" />

        <!-- Main Menu -->
        <section class="main-nav w-75">
          <ul
            class="m-0 d-flex align-items-center justify-content-end nav-actions"
          >
            <li>
              <div class="btn-group">
                <button
                  class="menu-trigger-button"
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  v-if="auth"
                >
                  <span>
                    <i class="fi fi-rr-circle-user action-icon"></i>
                  </span>
                  <span class="m-hidden">Account</span>
                </button>
                <button
                  class="menu-trigger-button"
                  data-toggle="dropdown"
                  type="button"
                  aria-expanded="false"
                  v-if="!auth"
                >
                  <span>
                    <img :src="user.profile_photo_url" loading="lazy" alt="" />
                  </span>
                  <span class="m-hidden" style="text-transform: capitalize">{{
                    user.fullname
                  }}</span>
                </button>
                <div class="dropdown-menu menu-dropdown">
                  <div class="px-3">
                    <button
                      class="w-100 py-2 auth-trigger"
                      type="button"
                      @click="login()"
                      v-if="auth"
                    >
                      Login
                    </button>
                    <button
                      class="menu-trigger-button"
                      type="button"
                      aria-expanded="false"
                      v-if="!auth"
                      @click="$router.push(`/account`)"
                    >
                      <span>
                        <img
                          :src="user.profile_photo_url"
                          loading="lazy"
                          alt=""
                        />
                      </span>
                      <h6 class="m-hidden" style="text-transform: capitalize">
                        {{ user.fullname }}
                      </h6>
                    </button>
                  </div>

                  <div class="dropdown-divider"></div>

                  <router-link
                    class="dropdown-item"
                    to="/account/orders-and-tracking"
                  >
                    <i class="fi fi-rr-box"></i>
                    <span>Your orders</span>
                  </router-link>

                  <router-link class="dropdown-item" to="/cars">
                    <i class="fi fi-rr-box"></i>
                    <span>Carlot</span>
                  </router-link>

                  <router-link
                    class="dropdown-item"
                    to="/account/reviews-and-ratings"
                  >
                    <i class="fi fi-rr-feedback"></i>
                    <span>Your reviews</span>
                  </router-link>

                  <router-link
                    class="dropdown-item"
                    to="/account/wallet/emart-wallet"
                  >
                    <i class="fi fi-rr-wallet"></i>
                    <span>Your wallet</span>
                  </router-link>

                  <router-link class="dropdown-item" to="/account/saved-items">
                    <i class="fi fi-rs-heart"></i>
                    <span>Saved items</span>
                  </router-link>
                </div>
              </div>
            </li>

            <li>
              <a
                href="https://support.sellersmart.ng/"
                target="_blank"
                class="menu-trigger-button"
                aria-expanded="false"
              >
                <span>
                  <i class="fi fi-rr-interrogation action-icon"></i>
                </span>
                <span class="m-hidden">Help</span>
              </a>
            </li>

            <li>
              <router-link
                class="menu-trigger-button"
                aria-expanded="false"
                to="/cart"
              >
                <span class="cart__count">
                  <i class="fi fi-rr-shopping-cart action-icon"></i>
                  <span class="count" v-if="cartItemsCount > 0">{{
                    cartItemsCount
                  }}</span>
                </span>
                <span class="m-hidden">Cart</span>
              </router-link>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import NavSearch from "./navSearch.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    NavSearch,
  },
  computed: {
    ...mapGetters("cartModule", ["cartItemsCount"]),
    routeName() {
      return this.$route.meta;
    },
  },
  data() {
    return {
      link: "",
      auth: null,
      user: [],
    };
  },
  methods: {
    menu() {
      this.$store.dispatch("handleMenu");
    },
    login() {
      if (window.sessionStorage.getItem("user") === "authenticated") {
        this.$refs.dash.click();
      } else {
        this.$store.state.AccessState = 1;
      }
    },
    saved() {
      if (window.sessionStorage.getItem("user") === "authenticated") {
        this.$refs.saved.click();
      } else {
        this.$store.state.AccessState = 1;
      }
    },
  },
  mounted() {
    this.user = JSON.parse(window.sessionStorage.getItem("userDetails"));
    if (window.sessionStorage.getItem("user") === "authenticated") {
      this.auth = false;
    } else {
      this.auth = true;
    }
  },
};
</script>

<style scoped>
.menu {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.menu .m-visible {
  display: none;
}
.action-icon {
  font-size: 1.5rem;
}

.menu-trigger-button span {
  margin-right: 0.5rem;
}

.menu-trigger-button:hover {
  text-decoration: none !important;
}

.cart__count {
  position: relative;
  margin-right: 0.5rem;
}
.cart__count .action-icon {
  position: relative;
}
.cart__count span {
  background-color: #004e3a;
  text-align: center;
  padding: 0.1rem;
  position: absolute;
  top: -30%;
  right: -50%;
  height: 20px;
  width: 20px;
  border-radius: 100%;
  font-size: 12px;
  font-family: THICCCBOI;
  font-weight: 300;
  color: #ffffff;
}

@media (min-width: 1024px) {
  .nav-actions {
    gap: 15px;
  }
  .action-icon {
    font-size: inherit;
  }
}

@media screen and (max-width: 990px) {
  .top-navigation .nav-main .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0rem;
  }
  .search {
    order: 3;
    width: 100%;
    grid-column: 1 / span 2;
  }

  .menu-trigger-button span {
    margin-right: 0;
  }

  .m-hidden {
    display: none;
  }

  .menu {
    width: 100% !important;
  }

  .menu .m-visible {
    display: block;
    z-index: 10;
    padding: 0 10px;
  }

  .img_logo {
    width: 100%;
    height: 4rem;
    object-fit: contain;
  }
}

@media screen and (max-width: 600px) {
  .top-navigation .nav-main .container {
    gap: 0px;
  }
  .search {
    order: 3;
    width: 100%;
    grid-column: 1 / span 2;
  }
  .m-hidden {
    display: none;
  }

  .cart__count span {
    right: -30%;
  }
}
</style>
